import { DescribeProperty } from '../../common';

export class SavedViewDeleteResponse {
  @DescribeProperty({ description: 'The number of entries affected', type: 'number' })
  affected: number;
}
